import { ReactElement, useCallback, useMemo, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, Container, TableCell } from "@material-ui/core";

import { QUERIES } from "../../../graphql";
import { AppVersion } from "../../../graphql/models/AppVersion";
import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";
import { AppVersionEditForm } from "./app-versions-form/app-versions-form";
import useAppVersionsStyle from "./app-versions.style";

function AppVersionsPage() {
  const classes = useAppVersionsStyle();
  const tableRef = useRef();

  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formAppVersion, setFormAppVersion] = useState<AppVersion | undefined>(
    void 0
  );

  const addNewAppVersion = () => {
    setFormAppVersion({} as AppVersion);
    setFormDialogOpened(true);
  };

  const editAppVersion = (appVersion) => {
    setFormAppVersion({
      ...appVersion,
    });
    setFormDialogOpened(true);
  };

  const gqlTableRowActions = useCallback((row: AppVersion) => {
    const actions: ReactElement[] = [];
    actions.push(<EditButton onClick={() => editAppVersion(row)} />);
    return actions;
  }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: ReactElement[] = [];
    actions.push(
      <Button
        key="addNewAppVersion"
        variant="contained"
        color="primary"
        onClick={() => addNewAppVersion()}
      >
        Aggiungi Nuovo
      </Button>
    );

    return actions;
  }, []);

  const columns = useMemo(() => {
    const cols = [
      "",
      "Data creazione",
      "Piattaforma",
      "Versione",
      "Progressivo build",
      "Obbliga aggiornamento?",
      "Obsoleta?",
    ];

    return cols;
  }, []);

  const onValueUpdatedSuccessfully = () => {
    setFormAppVersion(void 0);
    setFormDialogOpened(false);
    refreshTableContent();
  };

  const refreshTableContent = () => (tableRef as any).current?.refresh();

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <ActionToolbar title={"Versioni App"} actions={actionToolbarActions} />
      <GqlTable
        ref={tableRef}
        columns={columns.map((v) => (
          <TableCell>{v}</TableCell>
        ))}
        query={QUERIES.APP_VERSIONS}
        queryResultDataField="appVersions"
        rows={(row: AppVersion) => (
          <>
            <TableCell style={{ display: "flex", flexDirection: "row" }}>
              {gqlTableRowActions(row)}
            </TableCell>
            <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
            <TableCell>{row.platform}</TableCell>
            <TableCell>{row.version}</TableCell>
            <TableCell>{row.buildNumber}</TableCell>
            <TableCell>{row.mustUpdate === true ? "Sì" : "No"}</TableCell>
            <TableCell>{row.deprecated === true ? "Sì" : "No"}</TableCell>
          </>
        )}
      />
      <DialogWithActions
        fullScreen
        open={formDialogOpened}
        setOpen={setFormDialogOpened}
        title={"Aggiungi / Modifica Versione App"}
      >
        <AppVersionEditForm
          value={formAppVersion}
          onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          onValueDeleted={refreshTableContent}
        />
      </DialogWithActions>
    </Container>
  );
}

export default withRouter(AppVersionsPage);
